import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Init_des } from '../../components/Javascript/Init_des'
import init_pic_1 from "../../Images/Initiatives/Init9/image1.jpg";
import init_pic_2 from "../../Images/Initiatives/Init9/image2.jpg";
import init_pic_3 from "../../Images/Initiatives/Init9/image3.jpg";
import init_pic_4 from "../../Images/Initiatives/Init9/image4.jpg";
export const Init9 = props => {
  return (
    <>
      <Init_des
      i1={init_pic_1} i2={init_pic_2} i3={init_pic_3} i4={init_pic_4}
      title="SCIENCE LAB KIT DISTRIBUTION"
      date=" October 28, 2021"
      village=" Lecture Hall Complex, IIT Roorkee"
        p1='As Frederic joliot curie a French physicist said

        "The experiments should be setup to open as many windows as possible on the unforeseen". Students will get the knowledge of the methodology taught to them by their teachers.As experiments have an unmatched importance when it comes to learning science.'

        p2='Team UBA IIT Roorkee took a step towards imparting experimental knowledge to the village students by inviting Mr S. Bhanu Prakash (MS Mechanical, TAMU, USA), from Akshaya Knowledge Center, Telangana, to conduct a "Science experiment workshop".
        About 25 teachers from different schools of Haridwar and Dehradun gathered in Lecture Hall Complex, IIT Roorkee to attend the workshop. Workshop was also honoured by the presence of Chief guest of the event- Mr Vidyashankar Chaturvedi, Chief Education Officer, Haridwar; Guest of Honour - Dr M. Parida, Deputy Director, IIT Roorkee and Faculty Coordinator of UBA IIT Roorkee- Dr Bhanu Prakash Vellanki. It was conducted in 2 sessions of 3.5 hours each.'

        p3="In these sessions, Mr S. Bhanu Prakash performed different science experiments to train the teachers with the help of the experiment kits that were fabricated all by himself. The event went smoothly with the support of the team members and enthusiastic participation of teachers and was also appreciated by the chief guests.
"
      />
    </>
  )
}
